<template>
  <div class="teaser-list-calendar__day" :class="{ loading: loading }">
    <div
      class="teaser-list-calendar__container container container--full pdgx xxl-flex"
    >
      <div class="teaser-list-calendar__header pdgv0">
        <div class="teaser-list-calendar__date">
          <div class="day text-tiny">{{ tDay(day.date.day) }}</div>
          <div class="date text-h2 text-bold">{{ day.date.date }}</div>
          <div class="month text-tiny">{{ tMonth(day.date.month) }}</div>
        </div>
      </div>
      <ul class="list-stacked list-stacked--divided list-stacked--tight w-100">
        <template v-if="loading">
          <item-list v-for="n in 12" :key="n" :loading="true"></item-list>
        </template>
        <item-list
          v-for="result in day.results"
          :key="result.nid"
          :item="result"
          :active="result.nid === detailItem.nid"
        ></item-list>
      </ul>
    </div>
  </div>
</template>

<script>
import { DUMMY_SCHEDULE_DAY } from '@/settings/index'

import { mapState } from 'vuex'

import ItemList from './ItemList'

export default {
  components: {
    ItemList
  },
  props: {
    day: {
      type: Object,
      default: () => {
        return DUMMY_SCHEDULE_DAY
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('Schedule', {
      detailItem: (state) => state.detailItem
    })
  }
}
</script>
